import {Home} from './Home'

export const HomePage = Home;